/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiUserResponse,
    ApiUserResponseFromJSON,
    ApiUserResponseFromJSONTyped,
    ApiUserResponseToJSON,
} from './ApiUserResponse';

/**
 * 
 * @export
 * @interface ApiUsersResponse
 */
export interface ApiUsersResponse {
    /**
     * 
     * @type {Array<ApiUserResponse>}
     * @memberof ApiUsersResponse
     */
    elements: Array<ApiUserResponse>;
    /**
     * 
     * @type {number}
     * @memberof ApiUsersResponse
     */
    totalElementCount: number | null;
}

export function ApiUsersResponseFromJSON(json: any): ApiUsersResponse {
    return ApiUsersResponseFromJSONTyped(json, false);
}

export function ApiUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUsersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'elements': ((json['elements'] as Array<any>).map(ApiUserResponseFromJSON)),
        'totalElementCount': json['totalElementCount'],
    };
}

export function ApiUsersResponseToJSON(value?: ApiUsersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'elements': ((value.elements as Array<any>).map(ApiUserResponseToJSON)),
        'totalElementCount': value.totalElementCount,
    };
}

